<script setup lang="ts">
import { AVAILABLE_LANGUAGES, type AvailableLanguagesType } from '#root/global.type';
import { useUserStore } from '#store/user.store';
import { useLanguage } from '#webui/components/composables/useLanguage';
import { MonoSelectMenu } from '#webui/components/elements/MonoSelectMenu';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import UserMenu from './UserMenu.vue';

const { setLanguage, language } = useLanguage();

const userStore = useUserStore();
const selectedLanguage = ref<AvailableLanguagesType>(language.value);

watch(selectedLanguage, () => {
  setLanguage(selectedLanguage.value);
});

const { me } = storeToRefs(userStore);
</script>

<template>
  <div class="w-full">
    <div class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-8">
      <div class="flex justify-end flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div class="flex items-center gap-x-4 lg:gap-x-6">
          <MonoSelectMenu v-model="selectedLanguage" :options="[...AVAILABLE_LANGUAGES]" />
          <template v-if="me">
            <div class="block h-6 w-px bg-gray-900/10" aria-hidden="true" />
            <UserMenu :user="me" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
